import { Button } from "antd";
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../contexts/authContext";

export function SignOut() {
  const { signOut } = useContext(AuthContext);
  const history = useHistory();

  const signUserOut = async () => {
    if (signOut) {
      await signOut();
      history.push("/")

    }
  };

  return (
    <div className="sign-out-container">
      <Button
        type="primary"
        danger
        style={{ width: "100%", margin: "2px 0 8px 0" }}
        onClick={signUserOut}
      >
        Sign Out
      </Button>
    </div>
  );
}
